import { UsePaginatedDataHook } from '@lbcamden/lib-react';
import { keepPreviousData } from '@tanstack/react-query';

import { api } from '~/client/lib/trpc';
import { ActivityReportFilters, OfficerActivityResult } from '~/common/types/activityReport';
import { getEmptyResultSet } from '~/common/utils/data';

import { ActivityReportColumnId } from './types';

export const useActivityReport: UsePaginatedDataHook<
  OfficerActivityResult,
  ActivityReportColumnId,
  ActivityReportFilters
> = ({ page, pageSize, sortBy, filterValues }) => {
  const {
    data = getEmptyResultSet<OfficerActivityResult>(page, pageSize),
    isLoading: isLoadingFirst,
    isFetching,
    isPlaceholderData,
  } = api.activityReport.useQuery(
    {
      page,
      pageSize,
      sortBy,
      filters: filterValues as ActivityReportFilters,
    },
    { placeholderData: keepPreviousData },
  );

  const { results } = data;

  const loading = isLoadingFirst || (isFetching && (isPlaceholderData || !results?.length));
  const hasNoResults = !loading && !results?.length;

  return { ...data, loading, hasNoResults };
};
